import { Container } from "@mui/material";
import { useTheme } from "../../ThemeContext/ThemeContext.js";

const PageWrapper = ({ children, sx }) => {
  const { colors } = useTheme();

  return (
    <Container
      component="div"
      maxWidth={false}
      disableGutters
      sx={[
        {
          padding: "2rem 3.5rem !important",
          margin: 0,
          backgroundColor: colors.background.primary,
          overflowY: "auto",
          height: "100vh",
          display: "flex",
          flexDirection: "column",
        },
        sx,
      ]}
    >
      {children}
    </Container>
  );
};

export default PageWrapper;
